import React from 'react';

import styled from 'styled-components';

import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';

const EmptyTransfersContainer = styled.div`
    padding: 24px;
    min-height: calc(100vh - 328px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
const EmptyText = styled.div`
    max-width: 280px;
`;

const EmptyTransfers = () => {
    return (
        <EmptyTransfersContainer>
            <Row indent="16px">
                <Icon name="list-marked" color="secondary" />
            </Row>
            <EmptyText>
                <Text variant="div" color="secondary" size="secondary" textAlign="center">
                    Everything you send, receive, spend and&nbsp;withdraw will show up here
                </Text>
            </EmptyText>
        </EmptyTransfersContainer>
    );
};

export default EmptyTransfers;
